import React from 'react';

const EditIcon = () => <i className="material-icons align-bottom">edit</i>;
const EditOutline = () => <i className="material-icons-outlined align-bottom">edit</i>;

export { EditIcon as default, EditOutline }; 